import styled, { keyframes, css } from 'styled-components'
import { rem } from 'utils/common'
import { device } from 'components/Variable'

const blum = keyframes`
  0% {
    opacity: 1;
  }
  50% {
    opacity: .1;
  }
  100% {
    opacity: 1;
  }
`
const defaultStyle = css`
	background-color: ${({ theme }) => theme.color.grayOne};
	border-radius: ${rem(4)};
	width: 100%;
`

export const ShippingList = styled.div`
	position: relative;
	& > div:nth-child(2n) {
		animation-delay: 0.2s;
	}
	& > div:nth-child(3n) {
		animation-delay: 0.4s;
	}
	& > div:nth-child(4n) {
		animation-delay: 0.6s;
	}
	& > div:nth-child(5n) {
		animation-delay: 0.8s;
	}
	& > div:nth-child(6n) {
		animation-delay: 1s;
	}
	& > div:nth-child(7n) {
		animation-delay: 1.2s;
	}
	& > div:nth-child(8n) {
		animation-delay: 1.4s;
	}
	& > div:nth-child(9n) {
		animation-delay: 1.6s;
	}
	& > div:nth-child(10n) {
		animation-delay: 1.8s;
	}
	& > div:nth-child(11n) {
		animation-delay: 2s;
	}
`
export const Shipping = styled.div`
	display: flex;
	position: relative;
	background: ${({ theme }) => theme.color.secondary};
	border: ${rem(1)} solid ${({ theme }) => theme.color.secondary};
	border-radius: ${rem(8)};
	align-items: center;
	justify-content: space-between;
	padding: ${rem(20, 32)};
	max-width: ${rem(956)};
	margin: ${rem(10)} auto;
	animation: 1.3s infinite ${blum};

	@media (${device.tablet}) {
		padding: ${rem(22, 12)};
	}

	@media (${device.mobileM}) {
		padding: ${rem(18, 8)};
	}
`
export const Checkbox = styled.div`
	${defaultStyle};
	width: ${rem(20)};
	height: ${rem(20)};
	border-radius: 50%;
	margin-right: ${rem(20)};
	@media (${device.tablet}) {
		margin-right: ${rem(15)};
	}

	@media (${device.mobileM}) {
		margin-right: ${rem(10)};
	}
`
export const Title = styled.div`
	${defaultStyle};
	height: ${rem(19)};
	max-width: ${rem(200)};
	margin-bottom: ${rem(5)};
`
export const Price = styled.div`
	${defaultStyle};
	height: ${rem(19)};
	max-width: ${rem(50)};
	margin-bottom: ${rem(5)};
`
export const Description = styled.div`
	${defaultStyle};
	height: ${rem(14)};
	margin-bottom: ${rem(2)};
	@media (${device.mobileM}) {
		display: none;
	}
`
export const Logo = styled.div`
	${defaultStyle};
	height: ${rem(32)};
	width: ${rem(100)};
	margin: ${rem(0, 46, 0, 32)};
	@media (${device.tablet}) {
		margin: ${rem(0, 20, 0, 25)};
	}

	@media (${device.mobileM}) {
		height: ${rem(25)};
		width: ${rem(65)};
		margin: ${rem(0, 15)};
	}
`
export const Info = styled.div`
	fill: ${({ theme }) => theme.color.grayOne};
`
